import baseServices from '../../../services/base.services'

const getAll = async () => {
    try {
        var response = await baseServices.getDataTostacionDMH2({ opcion: 2, orden: 0, ultimo: 1, frecuencia: 1, periodo: 1 })
        if (response.data && response.data.length > 0) return response.data
        else return null
    }
    catch (e) {
        console.log(e)
        getAll()
    }
}

const getDataT = async () => {
    try {
        var response = await baseServices.getDataTostacionDMH2({ opcion: 9, orden: 1, ultimo: 0, frecuencia: 5, periodo: 1 })
        if (response.data && response.data.length > 0) return response.data
        else return null
    }
    catch (e) {
        console.log(e)
        getDataT()
    }
}

const getDataTG = async () => {
    try {
        var response = await baseServices.getDataTostacionDMH2({ opcion: 9, orden: 2, ultimo: 0, frecuencia: 5, periodo: 1 })
        if (response.data && response.data.length > 0) return response.data
        else return null
    }
    catch (e) {
        console.log(e)
        getDataTG()
    }
}

const getDataPA = async () => {
    try {
        var response = await baseServices.getDataTostacionDMH2({ opcion: 9, orden: 3, ultimo: 0, frecuencia: 5, periodo: 1 })
        if (response.data && response.data.length > 0) return response.data
        else return null
    }
    catch (e) {
        console.log(e)
        getDataPA()
    }
}

const exportedObject = {
    getAll,
    getDataT,
    getDataTG,
    getDataPA
}

export default exportedObject